import React from 'react';
import { compose } from 'redux';
import { Grid, Row, Col } from 'react-bootstrap';
import ContentNoSidebarTemplate from 'components/templates/ContentNoSidebar';
import HeaderContainer from 'containers/HeaderContainer';
import HomeTitleContainer from 'containers/home/HomeTitleContainer';
import HomeContentContainer from 'containers/home/HomeContentContainer';
import PageTitle from 'hoc/PageTitle';
import PageTheme from 'hoc/PageTheme';
import PageView from 'hoc/PageView';
import ProtectedRoute from 'hoc/ProtectedRoute';
import { userShowGGBranding } from 'helpers/showGGBrandingTheme';
import AnalyticsDataContainer from 'containers/AnalyticsDataContainer';
import ProtectedComponent from 'hoc/ProtectedComponent';
import { ShutdownNoticeTile } from 'components/molecules/ErrorTile';
import { DASHBOARD_ACCESS } from 'constants/capabilities';


const HomeContent = () => (
    <React.Fragment>
        <HomeContentContainer />
        <AnalyticsDataContainer />
    </React.Fragment>
);

const ProtectedHomeContent = ProtectedComponent({
    requiredCapabilities: [DASHBOARD_ACCESS],
    NoAccessComponent: () => <ShutdownNoticeTile>
        <Grid fluid>
            <Row>
                <Col sm={12} md={6} mdOffset={3} xlg={4} xlgOffset={4}>
                    <p>
                        This dashboard was deprecated as of June 30th, 2026.
                        Users should begin utilizing the new upgraded dashboard experience.
                        If you have not yet received access to your new dashboard,
                        please contact your Account Representative for assistance.
                    </p>
                    <p>
                        Thank you for your partnership as we continue to enhance our reporting and analytics experience.
                    </p>
                </Col>
            </Row>
        </Grid>
    </ShutdownNoticeTile>,
})(HomeContent);

const CreateHomePage = () => (
    <ContentNoSidebarTemplate
        header={<HeaderContainer hideHamburgerMenu />}
        title={<HomeTitleContainer />}>
        <ProtectedHomeContent />
    </ContentNoSidebarTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'Dashboards Home' }),
    PageView({ page: 'Viewed Home Page' }),
    PageTheme({ themeDefaults: { 'whitelabel.showGGBranding': userShowGGBranding } }),
    ProtectedRoute(),
)(CreateHomePage);



// WEBPACK FOOTER //
// ./src/components/pages/home/HomeIndex.js